/* eslint-disable */
import { hiprint } from 'vue-plugin-hiprint'

// 自定义设计元素1
export const aProvider = function (ops) {
  var addElementTypes = function (context) {
    context.removePrintElementTypes("aProviderModule");
    context.addPrintElementTypes(
      "aProviderModule",
      [
        new hiprint.PrintElementTypeGroup("平台", [
          {
            tid: 'aProviderModule.header', title: '单据表头', data: '单据表头', type: 'text',
            options: {
              "textContentVerticalAlign": "middle",
              testData: '单据表头', height: 32, fontSize: 16.5, fontWeight: "700", textAlign: "center", hideTitle: true
            }
          },
          {
            tid: 'aProviderModule.type', title: '单据类型', data: '单据类型', type: 'text',
            options: {
              "textContentVerticalAlign": "middle",
              testData: '单据类型', height: 30, fontSize: 15, fontWeight: "700", textAlign: "center", hideTitle: true
            }
          },
          {
            tid: 'aProviderModule.order', title: '订单编号', data: 'XS888888888', type: 'text',
            options: {
              field: 'orderId', testData: 'XS888888888', width: 200, height: 22, fontSize: 11, fontWeight: "700",
              textAlign: "left", textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'aProviderModule.date', title: '业务日期', data: '2020-01-01', type: 'text',
            options: {
              field: 'date', testData: '2020-01-01', height: 16, fontSize: 8, fontWeight: "700",
              textAlign: "left", textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'aProviderModule.barcode', title: '条形码', data: 'XS888888888', type: 'text',
            options: {
              field: 'barcode', testData: 'XS888888888', height: 32, fontSize: 12, lineHeight: 18, textType: "barcode"
            }
          },
          {
            tid: 'aProviderModule.qrcode', title: '二维码', data: 'XS888888888', type: 'text',
            options: {
              field: 'qrcode', testData: 'XS888888888', height: 50, width: 50, fontSize: 12, lineHeight: 18, textType: "qrcode"
            }
          },
          {
            tid: 'aProviderModule.platform', title: '平台名称', data: '平台名称', type: 'text',
            options: {
              field: 'companyName', "textContentVerticalAlign": "middle", "width": 500,
              testData: '平台名称', height: 36, fontSize: 18, fontWeight: "700", textAlign: "center", hideTitle: true
            }
          },
          { tid: 'aProviderModule.logo', title: 'Logo', data: '', type: 'image' },
        ]),
        new hiprint.PrintElementTypeGroup("库管", [
          {
            tid: 'aProviderModule.creater', title: '制单人', data: '李四', type: 'text',
            options: {
              field: 'creater', testData: '李四', height: 16, fontSize: 8, fontWeight: "700", textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'aProviderModule.printDate', title: '打印时间', data: '2022-01-01 09:00', type: 'text',
            options: {
              field: 'printDate', testData: '2022-01-01 09:00', height: 16, fontSize: 8, fontWeight: "700",
              textAlign: "left", textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'aProviderModule.signer', title: '库管签字', data: '', type: 'text',
            options: {
              title: '库管签字：', height: 16, fontSize: 8, fontWeight: "700",
              textAlign: "left", textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'aProviderModule.remark', title: '备注', data: '', type: 'text',
            options: {
              title: '备注', height: 16, fontSize: 8, fontWeight: "700", field: 'remark',
              textAlign: "left", textContentVerticalAlign: "middle"
            }
          },
        ]),
        new hiprint.PrintElementTypeGroup("表格/其他", [
          {
            tid: 'aProviderModule.table', title: '订单数据',
            type: 'table',
            "tableHeaderBackground": "#f5f5f5",
            options: {
              field: 'table',
              tableHeaderRepeat: 'first',
              tableFooterRepeat: 'last', 
            },
            editable: true,
            columnDisplayEditable: true,//列显示是否能编辑
            columnDisplayIndexEditable: true,//列顺序显示是否能编辑
            columnTitleEditable: true,//列标题是否能编辑
            columnResizable: true, //列宽是否能调整
            columnAlignEditable: true,//列对齐是否调整
            isEnableEditField: true, //编辑字段
            isEnableContextMenu: true, //开启右键菜单 默认true
            isEnableInsertRow: true, //插入行
            isEnableDeleteRow: true, //删除行
            isEnableInsertColumn: true, //插入列
            isEnableDeleteColumn: true, //删除列
            isEnableMergeCell: true, //合并单元格 
            "fontSize": 9,
            "columns": [
              [{
                "width": 34, "title": "NO", "field": "index", "checked": true, "fixed": true,
                "columnId": "index", "align": "center",
              }, {
                "width": 82, "title": "备注", "field": "remark",
                "checked": false, "fixed": true, "columnId": "remark", "align": "center"
              }, {
                "width": 54, "title": "产品图片", "field": "baseMaterialImg", "checked": true,"fixed": true,
                "columnId": "baseMaterialImg", "align": "center",
                "renderFormatter": "\nfunction imgFor(value, row, colIndex, options, rowIndex) {\n  if (value) {\n    return `<img style='width:100%' src='${value}'/>`\n  }\n  return `<div style='width:100%' class='hiprint-printElement-image-content'></div>`;\n}",
              }, {
                "width": 58, "title": "产品编号", "field": "baseMaterialNumber",
                "checked": true, "fixed": true, "columnId": "TM", "align": "center",
              }, {
                "width": 107, "title": "名称", "field": "baseMaterialName",
                "checked": true, "fixed": true, "columnId": "baseMaterialName", "align": "center"
              }, {
                "width": 54, "title": "类型", "field": "baseMaterialTypeName",
                "checked": true, "fixed": true, "columnId": "baseMaterialTypeName", "align": "center",
              }, {
                "width": 82, "title": "规格", "field": "specifications",
                "checked": true, "fixed": true, "columnId": "specifications", "align": "center"
              }, {
                "width": 52, "title": "单位", "field": "baseMaterialUnitName",
                "checked": true, "fixed": true, "columnId": "baseMaterialUnitName", "align": "center",
              }, {
                "width": 39, "title": "数量", "field": "baseAmount",
                "checked": true, "fixed": true, "columnId": "SL", "align": "center"
              }, {
                "width": 56, "title": "金额", "field": "baseMaterialTotalprice",
                "checked": true, "fixed": true, "columnId": "JE", "align": "center"
              }, {
                "width": 74, "title": "交货周期", "field": "baseReceiptDate",
                "checked": true, "fixed": true, "columnId": "baseReceiptDate", "align": "center",
              }
              ]
            ],
            footerFormatter(options, rows, data, currentPageGridRowsData) {
              if (data && data['totalCap']) {
                return "<tr><td style=\"padding:0 10px;border-right:1px solid #222\" colspan=\"4\">".concat('金额: ' + data['totals'], "",
                  `<td style=\"padding:0 10px\" colspan=\"110\">金额大写:${data.totalCap} </tr>`);
              }
              return '<tr><td style=\"padding:0 10px;border-right:1px solid #222\" colspan=\"4\">金额: <td style=\"padding:0 10px\" colspan=\"110\">金额大写: </tr>';
            }
          }, {
            tid: 'aProviderModule.Qtable', title: '通用订单',
            type: 'table',
            "tableHeaderBackground": "#fff",
            options: {
              field: 'table',
              tableHeaderRepeat: 'first',
              tableFooterRepeat: 'last',
              "fields": [
                { "text": "名称", "field": "baseMaterialName" },
                { "text": "数量", "field": "baseAmount" },
                { "text": "规格", "field": "specifications" },
                { "text": "条码", "field": "TM" },
                { "text": "单价", "field": "baseSalesUnitprice" },
                { "text": "金额", "field": "JE" },
                { "text": "备注", "field": "DETAIL" }
              ],
            },
            editable: true,
            columnDisplayEditable: true,//列显示是否能编辑
            columnDisplayIndexEditable: true,//列顺序显示是否能编辑
            columnTitleEditable: true,//列标题是否能编辑
            columnResizable: true, //列宽是否能调整
            columnAlignEditable: true,//列对齐是否调整
            isEnableEditField: true, //编辑字段
            isEnableContextMenu: true, //开启右键菜单 默认true
            isEnableInsertRow: true, //插入行
            isEnableDeleteRow: true, //删除行
            isEnableInsertColumn: true, //插入列
            isEnableDeleteColumn: true, //删除列
            isEnableMergeCell: true, //合并单元格 
            "fontSize": 9,
            "columns": [
              [{
                "width": 34, "title": "NO", "field": "index", "checked": true, "fixed": true,
                "columnId": "index", "align": "center",
              }, {
                "width": 82, "title": "备注", "field": "remark",
                "checked": false, "fixed": true, "columnId": "remark", "align": "center"
              }, {
                "width": 54, "title": "产品图片", "field": "baseMaterialImg", "checked": false,
                "columnId": "baseMaterialImg", "align": "center",
                "renderFormatter": "\nfunction imgFor(value, row, colIndex, options, rowIndex) {\n  if (value) {\n    return `<img style='width:100%' src='${value}'/>`\n  }\n  return `<div style='width:100%' class='hiprint-printElement-image-content'></div>`;\n}",
              }, {
                "width": 58, "title": "产品编号", "field": "baseMaterialNumber",
                "checked": false, "fixed": true, "columnId": "TM", "align": "center",
              }, {
                "width": 107, "title": "名称", "field": "baseMaterialName",
                "checked": true, "fixed": true, "columnId": "baseMaterialName", "align": "center"
              }, {
                "width": 54, "title": "类型", "field": "baseMaterialTypeName",
                "checked": true, "fixed": true, "columnId": "baseMaterialTypeName", "align": "center",
              }, {
                "width": 82, "title": "规格", "field": "specifications",
                "checked": true, "fixed": true, "columnId": "specifications", "align": "center"
              }, {
                "width": 52, "title": "单位", "field": "baseMaterialUnitName",
                "checked": true, "fixed": true, "columnId": "baseMaterialUnitName", "align": "center",
              }, {
                "width": 43, "title": "单价", "field": "baseMaterialUnitprice",
                "checked": true, "fixed": true, "columnId": "DJ", "align": "center"
              }, {
                "width": 39, "title": "数量", "field": "baseAmount",
                "checked": true, "fixed": true, "columnId": "SL", "align": "center"
              }, {
                "width": 56, "title": "金额", "field": "baseMaterialTotalprice",
                "checked": true, "fixed": true, "columnId": "JE", "align": "center"
              }, {
                "width": 74, "title": "交货周期", "field": "baseReceiptDate",
                "checked": true, "fixed": true, "columnId": "baseReceiptDate", "align": "center",
              }, {
                "width": 48, "title": "成本", "field": "baseMaterialPrice",
                "checked": false, "fixed": true, "columnId": "TM", "align": "center",
              }, {
                "width": 68, "title": "法兰标准", "field": "flange",
                "checked": false, "fixed": true, "columnId": "TM", "align": "center",
              }, {
                "width": 68, "title": "法兰材质", "field": "flange2",
                "checked": false, "fixed": true, "columnId": "TM", "align": "center",
              }, {
                "width": 68, "title": "主体材质", "field": "flange1",
                "checked": false, "fixed": true, "columnId": "TM", "align": "center",
              }
              ]
            ],
            footerFormatter(options, rows, data, currentPageGridRowsData) {
              if (data && data['totalCap']) {
                return "<tr><td style=\"padding:0 10px;border-right:1px solid #222\" colspan=\"4\">".concat('金额: ' + data['totals'], "",
                  `<td style=\"padding:0 10px\" colspan=\"110\">金额大写:${data.totalCap} </tr>`);
              }
              return '<tr><td style=\"padding:0 10px;border-right:1px solid #222\" colspan=\"4\">金额: <td style=\"padding:0 10px\" colspan=\"110\">金额大写: </tr>';
            }
          }, {
            tid: 'aProviderModule.Qtable1', title: '入库订单',
            type: 'table',
            "tableHeaderBackground": "#fff",
            options: {
              field: 'table',
              tableHeaderRepeat: 'first',
              tableFooterRepeat: 'last',
              "fields": [
                { "text": "名称", "field": "baseMaterialName" },
                { "text": "数量", "field": "baseAmount" },
                { "text": "规格", "field": "specifications" },
                { "text": "条码", "field": "TM" },
                { "text": "单价", "field": "baseSalesUnitprice" },
                { "text": "金额", "field": "JE" },
                { "text": "备注", "field": "DETAIL" }
              ],
            },
            editable: true,
            columnDisplayEditable: true,//列显示是否能编辑
            columnDisplayIndexEditable: true,//列顺序显示是否能编辑
            columnTitleEditable: true,//列标题是否能编辑
            columnResizable: true, //列宽是否能调整
            columnAlignEditable: true,//列对齐是否调整
            isEnableEditField: true, //编辑字段
            isEnableContextMenu: true, //开启右键菜单 默认true
            isEnableInsertRow: true, //插入行
            isEnableDeleteRow: true, //删除行
            isEnableInsertColumn: true, //插入列
            isEnableDeleteColumn: true, //删除列
            isEnableMergeCell: true, //合并单元格 
            "fontSize": 9,
            "columns": [
              [{
                "width": 34, "title": "NO", "field": "index", "checked": true, "fixed": true,
                "columnId": "index", "align": "center",
              }, {
                "width": 82, "title": "备注", "field": "remark",
                "checked": false, "fixed": true, "columnId": "remark", "align": "center"
              }, {
                "width": 54, "title": "产品图片", "field": "baseMaterialImg", "checked": false,
                "columnId": "baseMaterialImg", "align": "center",
                "renderFormatter": "\nfunction imgFor(value, row, colIndex, options, rowIndex) {\n  if (value) {\n    return `<img style='width:100%' src='${value}'/>`\n  }\n  return `<div style='width:100%' class='hiprint-printElement-image-content'></div>`;\n}",
              }, {
                "width": 58, "title": "产品编号", "field": "baseMaterialNumber",
                "checked": false, "fixed": true, "columnId": "TM", "align": "center",
              }, {
                "width": 107, "title": "名称", "field": "baseMaterialName",
                "checked": true, "fixed": true, "columnId": "baseMaterialName", "align": "center"
              }, {
                "width": 54, "title": "类型", "field": "baseMaterialTypeName",
                "checked": true, "fixed": true, "columnId": "baseMaterialTypeName", "align": "center",
              }, {
                "width": 82, "title": "规格", "field": "specifications",
                "checked": true, "fixed": true, "columnId": "specifications", "align": "center"
              }, {
                "width": 52, "title": "单位", "field": "baseMaterialUnitName",
                "checked": true, "fixed": true, "columnId": "baseMaterialUnitName", "align": "center",
              }, {
                "width": 43, "title": "单价", "field": "baseMaterialUnitprice",
                "checked": true, "fixed": true, "columnId": "DJ", "align": "center"
              }, {
                "width": 39, "title": "数量", "field": "baseAmount",
                "checked": true, "fixed": true, "columnId": "SL", "align": "center"
              }, {
                "width": 56, "title": "金额", "field": "baseMaterialTotalprice",
                "checked": true, "fixed": true, "columnId": "JE", "align": "center"
              }, {
                "width": 54, "title": "标准", "field": "cc1",
                "checked": false, "fixed": true, "columnId": "cc1", "align": "center",
              }, {
                "width": 54, "title": "A类", "field": "cc2",
                "checked": false, "fixed": true, "columnId": "cc2", "align": "center",
              }, {
                "width": 54, "title": "B类", "field": "cc3",
                "checked": false, "fixed": true, "columnId": "cc3", "align": "center",
              }, {
                "width": 54, "title": "衬氟", "field": "cc4",
                "checked": false, "fixed": true, "columnId": "cc4", "align": "center",
              }, {
                "width": 54, "title": "排污", "field": "cc5",
                "checked": false, "fixed": true, "columnId": "cc5", "align": "center",
              }, {
                "width": 54, "title": "废品", "field": "cc6",
                "checked": false, "fixed": true, "columnId": "cc6", "align": "center",
              },
              ]
            ],
            footerFormatter(options, rows, data, currentPageGridRowsData) {
              if (data && data['totalCap']) {
                return "<tr><td style=\"padding:0 10px;border-right:1px solid #222\" colspan=\"4\">".concat('金额: ' + data['totals'], "</td>",
                  `<td style=\"padding:0 10px\" colspan=\"110\">金额大写:${data.totalCap} </td></tr>`);
              }
              return '<tr><td style=\"padding:0 10px;border-right:1px solid #222\" colspan=\"4\">金额: </td><td style=\"padding:0 10px\" colspan=\"110\">金额大写: </td></tr>';
            }
          }, {
            tid: 'aProviderModule.infotable', title: '说明订单',
            type: 'table',
            "tableHeaderBackground": "#f5f5f5",
            options: {
              field: 'infotable',
              tableHeaderRepeat: 'first',
              tableFooterRepeat: 'last',
              "fields": [
                { "text": "名称", "field": "baseMaterialName" },
                { "text": "数量", "field": "baseAmount" },
                { "text": "规格", "field": "specifications" },
                { "text": "条码", "field": "TM" },
                { "text": "单价", "field": "baseSalesUnitprice" },
                { "text": "金额", "field": "JE" },
                { "text": "备注", "field": "DETAIL" }
              ],
            },
            editable: true,
            columnDisplayEditable: true,//列显示是否能编辑
            columnDisplayIndexEditable: true,//列顺序显示是否能编辑
            columnTitleEditable: true,//列标题是否能编辑
            columnResizable: true, //列宽是否能调整
            columnAlignEditable: true,//列对齐是否调整
            isEnableEditField: true, //编辑字段
            isEnableContextMenu: true, //开启右键菜单 默认true
            isEnableInsertRow: true, //插入行
            isEnableDeleteRow: true, //删除行
            isEnableInsertColumn: true, //插入列
            isEnableDeleteColumn: true, //删除列
            isEnableMergeCell: true, //合并单元格 
            "fontSize": 9,
            "columns": [
              [{
                "width": 34, "title": "NO", "field": "index", "checked": true, "fixed": true,
                "columnId": "index", "align": "center",
              }, {
                "width": 82, "title": "备注", "field": "remark",
                "checked": false, "columnId": "remark", "align": "center"
              }, {
                "width": 54, "title": "产品图片", "field": "baseMaterialImg", "checked": false,
                "columnId": "baseMaterialImg", "align": "center",
                "renderFormatter": "\nfunction imgFor(value, row, colIndex, options, rowIndex) {\n  if (value) {\n    return `<img style='width:100%' src='${value}'/>`\n  }\n  return `<div style='width:100%' class='hiprint-printElement-image-content'></div>`;\n}",
              }, {
                "width": 58, "title": "产品编号", "field": "baseMaterialNumber",
                "checked": false, "fixed": true, "columnId": "TM", "align": "center",
              }, {
                "width": 107, "title": "名称", "field": "baseMaterialName",
                "checked": true, "fixed": true, "columnId": "baseMaterialName", "align": "center"
              }, {
                "width": 54, "title": "类型", "field": "baseMaterialTypeName",
                "checked": true, "fixed": true, "columnId": "baseMaterialTypeName", "align": "center",
              }, {
                "width": 82, "title": "规格", "field": "specifications",
                "checked": true, "fixed": true, "columnId": "specifications", "align": "center"
              }, {
                "width": 52, "title": "单位", "field": "baseMaterialUnitName",
                "checked": true, "fixed": true, "columnId": "baseMaterialUnitName", "align": "center",
              }, {
                "width": 43, "title": "单价", "field": "baseMaterialUnitprice",
                "checked": true, "fixed": true, "columnId": "DJ", "align": "center"
              }, {
                "width": 39, "title": "数量", "field": "baseAmount",
                "checked": true, "fixed": true, "columnId": "SL", "align": "center"
              }, {
                "width": 56, "title": "金额", "field": "baseMaterialTotalprice",
                "checked": true, "fixed": true, "columnId": "JE", "align": "center"
              }, {
                "width": 74, "title": "备注", "field": "remark",
                "checked": true, "fixed": true, "columnId": "baseReceiptDate", "align": "center",
              },
              ]
            ],
            footerFormatter(options, rows, data, currentPageGridRowsData) {
              return `<tr><td colspan='100' style="padding:5px">说明：<br/>1.以上货品请核对数量，如有质量问题，请在3日内联系本公司。<br/>
                   2.本送货单一经签收如无异议，视同贵司收到全部货物，表示购销双方权利义务已确认！<br/>
                   3.第一联(白底 )内部留底，第二联(红底) 客户回签，第三、四联客户留底。</td></tr>`
            }
          },
          {
            tid: 'aProviderModule.totals', title: '总价', type: 'text',
            options: {
              field: 'totals', testData: '100', height: 16, fontSize: 9, textAlign: "left", textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'aProviderModule.totalCap', title: '金额大写', type: 'text',
            options: {
              field: 'totalCap', testData: '壹佰', height: 16, fontSize: 9, textAlign: "left", textContentVerticalAlign: "middle"
            }
          },
          { tid: 'aProviderModule.customText', title: '文本', customText: '自定义文本', custom: true, type: 'text' },
          {
            tid: 'aProviderModule.longText', title: '长文本', type: 'longText', options: {
              field: 'test.longText',
              width: 200,
              testData: '长文本分页/不分页测试',
              "fontSize": 9.5,
              "lineHeight": 16.5,
              "styler": "function f2(value, options, target,templateData){ \n  target.css({\"border\":\"1px solid #333\",padding:\"5px\"})\n}"
            },
          },
          {
            tid: 'aProviderModule.longTextP', title: '备注文本', type: 'longText', options: {
              field: 'test.longText',
              width: 200,
              testData: '长文本分页/不分页测试',
              "fontSize": 9.5,
              "lineHeight": 16.5,
              "styler": "function f2(value, options, target,templateData){ \n  target.css({\"border\":\"1px solid #333\",padding:\"5px\"})\n}"
            },
          }, {
            tid: 'aProviderModule.lineText', title: '横线文本', data: '', type: 'text',
            options: {
              title: '名称', height: 16, fontSize: 8, field: 'remark',
              textAlign: "left", textContentVerticalAlign: "middle"
            },
            "formatter": function (title, value, options, templateData, target) {
              return `<div style=\"display:inline-block;grid-column-start: 2;grid-column-end: 99;height: 16;border-bottom: 1px solid #444;\">
              ${value}&nbsp</div>`
            }
          },

        ]),
        new hiprint.PrintElementTypeGroup("辅助", [
          {
            tid: 'aProviderModule.hline', title: '横线', type: 'hline'
          },
          {
            tid: 'aProviderModule.vline', title: '竖线', type: 'vline'
          },
          {
            tid: 'aProviderModule.rect', title: '矩形', type: 'rect'
          },
          {
            tid: 'aProviderModule.oval', title: '椭圆', type: 'oval'
          },
          {
            tid: 'aProviderModule.barcode', title: '条形码', type: 'barcode',
          },
          {
            tid: "defaultModule.html", title: "html", type: "html",
            options: {
              field: 'html',
            },
            formatter: function (data, options) {
              return '<div style="height:50pt;width:50pt;background:red;border-radius: 50%;"></div>';
            }
          },
        ]),
        new hiprint.PrintElementTypeGroup("客户相关", [
          {
            tid: 'bProviderModule.baseCustomerName', title: '客户名称', type: 'text',
            options: {
              field: 'baseCustomerName', testData: '客户名称', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.baseCustomerNumber', title: '客户编号', type: 'text',
            options: {
              field: 'baseCustomerNumber', testData: '客户编号', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.baseCustomerPhone', title: '客户电话', type: 'text',
            options: {
              field: 'baseCustomerPhone', testData: '客户电话', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.baseCustomerShortname', title: '客户简称', type: 'text',
            options: {
              field: 'baseCustomerShortname', testData: '客户简称', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.baseCustomerEmail', title: '客户邮箱', type: 'text',
            options: {
              field: 'baseCustomerEmail', testData: '客户邮箱', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.baseCustomerContactsName', title: '客户联系人', type: 'text',
            options: {
              field: 'baseCustomerContactsName', testData: '客户联系人', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.baseCustomerAddress', title: '客户地址', type: 'text',
            options: {
              field: 'baseCustomerAddress', testData: '客户地址', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
        ]),
        new hiprint.PrintElementTypeGroup("供应商相关", [
          {
            tid: 'bProviderModule.baseSupplierName', title: '供应商名称', type: 'text',
            options: {
              field: 'baseSupplierName', testData: '供应商名称', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.baseSupplierNumber', title: '供应商编号', type: 'text',
            options: {
              field: 'baseSupplierNumber', testData: '供应商编号', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.baseSupplierPhone', title: '供应商电话', type: 'text',
            options: {
              field: 'baseSupplierPhone', testData: '供应商电话', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.baseSupplierShortname', title: '供应商简称', type: 'text',
            options: {
              field: 'baseSupplierShortname', testData: '供应商简称', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.baseSupplierEmail', title: '供应商邮箱', type: 'text',
            options: {
              field: 'baseSupplierEmail', testData: '供应商邮箱', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.baseSupplierContactsName', title: '供应商联系人', type: 'text',
            options: {
              field: 'baseSupplierContactsName', testData: '供应商联系人', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.baseSupplierAddress', title: '供应商地址', type: 'text',
            options: {
              field: 'baseSupplierAddress', testData: '供应商地址', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
        ]),
        new hiprint.PrintElementTypeGroup("公司相关", [
          {
            tid: 'bProviderModule.companyName', title: '公司名称', type: 'text',
            options: {
              field: 'companyName', testData: '公司名称', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.companyId', title: '公司编号', type: 'text',
            options: {
              field: 'companyId', testData: '公司编号', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.companyPhone', title: '公司电话', type: 'text',
            options: {
              field: 'companyPhone', testData: '公司电话', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.companyPhone', title: '公司电话', type: 'text',
            options: {
              field: 'companyPhone', testData: '公司电话', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.companyEmail', title: '公司邮箱', type: 'text',
            options: {
              field: 'companyEmail', testData: '公司邮箱', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.companyContactsName', title: '公司联系人', type: 'text',
            options: {
              field: 'companyContactsName', testData: '公司联系人', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.companyAddress', title: '公司地址', type: 'text',
            options: {
              field: 'companyAddress', testData: '公司地址', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.companyWeb', title: '公司网址', type: 'text',
            options: {
              field: 'companyWeb', testData: '公司网址', height: 16, fontSize: 8, width: 200, textContentVerticalAlign: "middle"
            }
          },
        ]),
      ]
    );
  };
  return {
    addElementTypes: addElementTypes
  };
};

// 自定义设计元素2
export const bProvider = function (ops) {
  var addElementTypes = function (context) {
    context.removePrintElementTypes("bProviderModule");
    context.addPrintElementTypes(
      "bProviderModule",
      [
        new hiprint.PrintElementTypeGroup("常规", [
          {
            tid: 'bProviderModule.header', title: '单据表头', data: '单据表头', type: 'text',
            options: {
              testData: '单据表头',
              height: 17,
              fontSize: 16.5,
              fontWeight: "700",
              textAlign: "center",
              hideTitle: true
            }
          },
          {
            tid: 'bProviderModule.type', title: '单据类型', data: '单据类型', type: 'text',
            options: {
              testData: '单据类型',
              height: 16,
              fontSize: 15,
              fontWeight: "700",
              textAlign: "center",
              hideTitle: true
            }
          },
          {
            tid: 'bProviderModule.order', title: '订单编号', data: 'XS888888888', type: 'text',
            options: {
              field: 'orderId',
              testData: 'XS888888888',
              height: 16,
              fontSize: 8,
              fontWeight: "700",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.date', title: '业务日期', data: '2020-01-01', type: 'text',
            options: {
              field: 'date',
              testData: '2020-01-01',
              height: 16,
              fontSize: 8,
              fontWeight: "700",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.barcode', title: '条形码', data: 'XS888888888', type: 'text',
            options: {
              field: 'barcode',
              testData: 'XS888888888',
              height: 32,
              fontSize: 12,
              lineHeight: 18,
              textType: "barcode"
            }
          },
          {
            tid: 'bProviderModule.qrcode', title: '二维码', data: 'XS888888888', type: 'text',
            options: {
              field: 'qrcode',
              testData: 'XS888888888',
              height: 32,
              fontSize: 12,
              lineHeight: 18,
              textType: "qrcode"
            }
          },
          {
            tid: 'bProviderModule.platform', title: '平台名称', data: '平台名称', type: 'text',
            options: {
              testData: '平台名称',
              height: 17,
              fontSize: 16.5,
              fontWeight: "700",
              textAlign: "center",
              hideTitle: true
            }
          },
          { tid: 'bProviderModule.image', title: 'Logo', data: '', type: 'image' },
        ]),
        new hiprint.PrintElementTypeGroup("客户", [
          {
            tid: 'bProviderModule.khname', title: '客户名称', data: '高级客户', type: 'text',
            options: {
              field: 'name',
              testData: '高级客户',
              height: 16,
              fontSize: 8,
              fontWeight: "700",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.tel', title: '客户电话', data: '18888888888', type: 'text',
            options: {
              field: 'tel',
              testData: '18888888888',
              height: 16,
              fontSize: 8,
              fontWeight: "700",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
        ]),
        new hiprint.PrintElementTypeGroup("表格/其他", [
          {
            tid: 'bProviderModule.table', title: '订单数据',
            type: 'table',
            options: {
              field: 'table',
              fields: [
                { text: '名称', field: 'NAME' },
                { text: '数量', field: 'SL' },
                { text: '规格', field: 'GG' },
                { text: '条码', field: 'TM' },
                { text: '单价', field: 'DJ' },
                { text: '金额', field: 'JE' },
                { text: '备注', field: 'DETAIL' },
              ],
            },
            editable: true,
            columnDisplayEditable: true,//列显示是否能编辑
            columnDisplayIndexEditable: true,//列顺序显示是否能编辑
            columnTitleEditable: true,//列标题是否能编辑
            columnResizable: true, //列宽是否能调整
            columnAlignEditable: true,//列对齐是否调整
            columns: [
              [
                { title: '名称', align: 'center', field: 'NAME', width: 100 },
                { title: '数量', align: 'center', field: 'SL', width: 100 },
                { title: '条码', align: 'center', field: 'TM', width: 100 },
                { title: '规格', align: 'center', field: 'GG', width: 100 },
                { title: '单价', align: 'center', field: 'DJ', width: 100 },
                { title: '金额', align: 'center', field: 'JE', width: 100 },
                { title: '备注', align: 'center', field: 'DETAIL', width: 100 },
              ]
            ],
            footerFormatter: function (options, rows, data, currentPageGridRowsData) {
              if (data && data['totalCap']) {
                return `<td style="padding:0 10px" colspan="100">${'应收金额大写: ' + data['totalCap']}</td>`
              }
              return '<td style="padding:0 10px" colspan="100">应收金额大写: </td>'
            },
          },
          { tid: 'bProviderModule.customText', title: '文本', customText: '自定义文本', custom: true, type: 'text' },
          {
            tid: 'bProviderModule.longText', title: '长文本', type: 'longText', options: {
              field: 'test.longText',
              width: 200,
              testData: '长文本分页/不分页测试'
            },
          },
        ]),
        new hiprint.PrintElementTypeGroup("辅助", [
          {
            tid: 'bProviderModule.hline',
            title: '横线',
            type: 'hline'
          },
          {
            tid: 'bProviderModule.vline',
            title: '竖线',
            type: 'vline'
          },
          {
            tid: 'bProviderModule.rect',
            title: '矩形',
            type: 'rect'
          },
          {
            tid: 'bProviderModule.oval',
            title: '椭圆',
            type: 'oval'
          }
        ]),
        new hiprint.PrintElementTypeGroup("客户相关", [
          {
            tid: 'bProviderModule.baseCustomerName', title: '客户名称', type: 'text',
            options: {
              field: 'baseCustomerName', testData: '客户名称', height: 16, fontSize: 8, textAlign: "left", textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.baseCustomerNumber', title: '客户编号', type: 'text',
            options: {
              field: 'baseCustomerNumber', testData: '客户编号', height: 16, fontSize: 8, textAlign: "left", textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.baseCustomerPhone', title: '客户电话', type: 'text',
            options: {
              field: 'baseCustomerPhone', testData: '客户电话', height: 16, fontSize: 8, textAlign: "left", textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.baseCustomerShortname', title: '客户简称', type: 'text',
            options: {
              field: 'baseCustomerShortname', testData: '客户简称', height: 16, fontSize: 8, textAlign: "left", textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.baseCustomerEmail', title: '客户邮箱', type: 'text',
            options: {
              field: 'baseCustomerEmail', testData: '客户邮箱', height: 16, fontSize: 8, textAlign: "left", textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.baseCustomerContactsName', title: '客户联系人', type: 'text',
            options: {
              field: 'baseCustomerContactsName', testData: '客户联系人', height: 16, fontSize: 8, textAlign: "left", textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.baseCustomerAddress', title: '客户地址', type: 'text',
            options: {
              field: 'baseCustomerAddress', testData: '客户地址', height: 16, fontSize: 8, textAlign: "left", textContentVerticalAlign: "middle"
            }
          },
        ])
      ]
    );
  };
  return {
    addElementTypes: addElementTypes
  };
};

function imgFor(value, row, colIndex, options, rowIndex) {
  if (value) {
    return `<img style='width:100%' src='${value}'/>`
  }
  return `<div style='width:100%' class='hiprint-printElement-image-content'></div>`;
}

function footerFormatter(options, rows, data, currentPageGridRowsData) {
  return `<td colspan='100' style=\"padding:5px;line-hight:2\">
  协助事项：<br/>
  1、本单一式四联。<br/>
  2、来料检验判定为不良物料的，7天内供应商取回；过期不取的，不负保管责任。<br/>
  3、已记录内容需要更改时，请在记录上划线并签名。<br/>
  4、来料标签需严格按《标签和追溯编码规则管理规定》执行，否则，将按来料包装不规范予以退货处理。</td > `;
}

// type: 1供货商 2经销商
export default [{
  name: '基础数据',
  value: 'aProviderModule',
  type: 1,
  f: aProvider()
}, {
  name: 'B设计',
  value: 'bProviderModule',
  type: 2,
  f: bProvider()
},]

function formatter(data, options) {
  console.log("datadatadatadata", data)
  if (data) {
    return `<table id="" style="border-collapse: collapse; margin-left: auto; margin-right: auto;width:100%" border="1">
    <tbody>
    <tr>
    <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">公司名称</td>
    <td style="height: 30px;padding:0px 8px; font-size:16px;">${data.companyName}</td>
    </tr>
    <tr>
    <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">税&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号</td>
    <td style="height: 30px;padding:0px 8px; font-size:16px;">${data.companyName}</td>
    </tr>
    <tr>
    <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址</td>
    <td style="height: 30px;padding:0px 8px; font-size:16px;">${data.companyName}</td>
    </tr>
    <tr>
    <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">电&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;话</td>
    <td style="height: 30px;padding:0px 8px; font-size:16px;">${data.companyName}</td>
    </tr>
    <tr>
    <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">开&nbsp;&nbsp;户&nbsp;&nbsp;行</td>
    <td style="height: 30px;padding:0px 8px; font-size:16px;">${data.companyName}</td>
    </tr>
    <tr>
    <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">账&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号</td>
    <td style="height: 30px;padding:0px 8px; font-size:16px;">${data.companyName}</td>
    </tr>
    <tr>
    <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">收票货地址</td>
    <td style="height: 30px;padding:0px 8px; font-size:16px;">${data.companyName}</td>
    </tr>
    </tbody>
    </table>`;
  }
  return `<table id="" style="border-collapse: collapse; margin-left: auto; margin-right: auto;width:100%" border="1">
  <tbody>
  <tr>
  <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">公司名称</td>
  <td style="height: 30px;padding:0px 8px; font-size:16px;"></td>
  </tr>
  <tr>
  <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">税&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号</td>
  <td style="height: 30px;padding:0px 8px; font-size:16px;"></td>
  </tr>
  <tr>
  <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址</td>
  <td style="height: 30px;padding:0px 8px; font-size:16px;"></td>
  </tr>
  <tr>
  <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">电&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;话</td>
  <td style="height: 30px;padding:0px 8px; font-size:16px;"></td>
  </tr>
  <tr>
  <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">开&nbsp;&nbsp;户&nbsp;&nbsp;行</td>
  <td style="height: 30px;padding:0px 8px; font-size:16px;"></td>
  </tr>
  <tr>
  <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">账&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号</td>
  <td style="height: 30px;padding:0px 8px; font-size:16px;"></td>
  </tr>
  <tr>
  <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">收票货地址</td>
  <td style="height: 30px;padding:0px 8px; font-size:16px;"></td>
  </tr>
  </tbody>
  </table>`;
}
function f1(title, value, options, templateData, target) {
  return `1 此价格含<span style="padding:0 8px;border-bottom: 1px solid #555;">${value}%</span>税，<span style=";padding:0 8px;border-bottom: 1px solid #555;">${value}</span>运费。
2 此产品由<span style="padding:0 8px;border-bottom: 1px solid #555;">${value}</span>合成橡胶、尼龙帘线和镀铜钢丝构成。法兰为<span style="padding:0 8px;border-bottom: 1px solid #555;">${value}</span>材质，表面<span style="padding:0 8px;border-bottom: 1px solid #555;">${value}</span>防腐处理。
3 此批货物货期为    天。
4 本公司产品由上海市质量监督技术检验研究院承检。
5 本公司产品由PICC中国人保财险承保产品责任险。`
}
function f2(value, options, target, templateData) {
  target.css({ "border": "1px solid #333", padding: "5px" })
}

function f21(value, options, target, templateData) {
  var str = `<table id="" style="border-collapse: collapse; margin-left: auto; margin-right: auto;width:100%" border="1">
  <tbody>
  <tr>
  <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">公司名称</td>
  <td style="height: 30px;padding:0px 8px; font-size:16px;">${value?.companyName}</td>
  </tr>
  <tr>
  <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">税&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号</td>
  <td style="height: 30px;padding:0px 8px; font-size:16px;">${value?.companyId}</td>
  </tr>
  <tr>
  <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址</td>
  <td style="height: 30px;padding:0px 8px; font-size:16px;">${value?.companyAddress}</td>
  </tr>
  <tr>
  <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">电&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;话</td>
  <td style="height: 30px;padding:0px 8px; font-size:16px;">${value?.companyPhone}</td>
  </tr>
  <tr>
  <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">开&nbsp;&nbsp;户&nbsp;&nbsp;行</td>
  <td style="height: 30px;padding:0px 8px; font-size:16px;">${value?.companyBank}</td>
  </tr>
  <tr>
  <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">账&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号</td>
  <td style="height: 30px;padding:0px 8px; font-size:16px;">${value?.companyBankNumber}</td>
  </tr>
  <tr>
  <td style="height: 30px; width: 7em;font-size:18px; text-align: center;">收票货地址</td>
  <td style="height: 30px;padding:0px 8px; font-size:16px;">${value?.companyPaperAddress}</td>
  </tr>
  </tbody>
  </table>`
  target.html(str)
}
function footerFormatter1(options, rows, data, currentPageGridRowsData) {
  data = data || {}
  return `<tr> 
      <tr> 
      <td>发货方式</td>
      <td><select>
      <option>物流</option>
      <option>快运</option>
      <option>快递</option>
      <option>自送</option>
      <option>货拉拉</option>
      <option>运满满</option></select></td>
      <td>是否送货</td>
      <td><select>
      <option>送货</option>
      <option>不送</option></select></td>
      <td>运费方式</td>
      <td><select>
      <option>到付</option>
      <option>垫付</option>
      <option>现付</option></select></td> 
      <td></td> 
      <td></td> 
      <td></td> 
      </tr>
      `
}
function footerFormatter22(options, rows, data, currentPageGridRowsData) {
  data = data || {}
  return `<tr>
    <td style=\"padding:0 10px;border-right:1px solid #222\" colspan=\"4\">金额:${data['totals']}</td>
    <td style=\"padding:0 10px\" colspan=\"110\">金额大写：${data.totalCap} </td>
    </tr><tr>
    <td style=\"padding:0 10px;line-height:1.5\" colspan=\"110\">注：
    1：以上货物请当面核对数量，如有异议请及时联系本公司，逾期概不负责。<br>
    &emsp;&emsp;&nbsp;2：验收后，请签字盖章，将回单回传本公司。<br>
    &emsp;&emsp;&nbsp;3：请严格按照产品安装说明进行安装，或联系本公司咨询。</td>
    
    </tr>`
}

function imgSpan(value, row, colIndex, options, rowIndex) {
  if (row) {
    setTimeout(() => {
      if (row.colSpan > 0) {
        var divElement = document.getElementById("targetDiv" + colIndex + rowIndex);
        if (divElement) {
          var tdElement = divElement.parentNode;
          if (tdElement.tagName.toLowerCase() === 'td') {
            tdElement.setAttribute('rowspan', newRowspanValue);
          }
        }
      } else {
        var divElements = document.getElementById("noneDiv" + colIndex + rowIndex)
        console.log("noneDiv" + colIndex + rowIndex, divElements)
        if (divElements) {
          var tdElement = divElements.parentNode;
          console.log(tdElement)
          if (tdElement.tagName.toLowerCase() === 'td') {
            tdElement.style.display = 'none';
          }
        }
      }
    }, 500);
    if (row.colSpan > 0) { 
      var newRowspanValue = row.colSpan;
      
  if (value) {
    value = row.imageBaseUrl + value
    return `<div id="targetDiv${colIndex}${rowIndex}"><img style='width:100%' src='${value??""}'/></div>`
  } else{
    return `<div id="targetDiv${colIndex}${rowIndex}">${value ?? ""}</div>`;
  }
    }
  }
  return `<div id="noneDiv${colIndex}${rowIndex}"></div>`;
}

function textSpan(value, row, colIndex, options, rowIndex) {
  if (row) {
    setTimeout(() => {
      if (row.colSpan > 0) {
        var divElement = document.getElementById("targetDiv" + colIndex + rowIndex);
        if (divElement) {
          var tdElement = divElement.parentNode;
          if (tdElement.tagName.toLowerCase() === 'td') {
            tdElement.setAttribute('rowspan', newRowspanValue);
          }
        }
      } else {
        var divElements = document.getElementById("noneDiv" + colIndex + rowIndex) 
        if (divElements) {
          var tdElement = divElements.parentNode; 
          if (tdElement.tagName.toLowerCase() === 'td') {
            tdElement.style.display = 'none';
          }
        }
      }
    }, 1);
    if (row.colSpan > 0) { 
      var newRowspanValue = row.colSpan;
      return `<div id="targetDiv${colIndex}${rowIndex}">${value ?? ""}</div>`;
    }
  }
  return `<div id="noneDiv${colIndex}${rowIndex}"></div>`;
}